import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import LANGUAGES_API from '../../controllers/languages';
import Entry from './Entry';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

const log = new Logger('ERRORS_WARNINGS_LIST', LOG_LEVELS.DEBUG);

class ErrorsAndWarningsListForm extends Component {
  render() {
    log.debug('render(): ', this.props);
    const fieldValues = this.props.fieldValues;
    if(_.isEmpty(this.props.list) || !_.isArray(this.props.list)) {
      return (
        <div>
          <h2>No {this.props.type} items</h2>
          <table className="card-table mb20">
              <thead>
                <tr>
                  <th><LanguageStringResolver string="errorsAndWarnings_documentReference" /></th>
                  <th><LanguageStringResolver string="errorsAndWarnings_description" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="5"><LanguageStringResolver string="errorsAndWarnings_noResults" /></td>
                </tr>
              </tbody>
            </table>
        </div>
        );
    }

    return (
      <div>
        <h2>Found {this.props.type} List ({this.props.list.length})</h2>
        <table className="card-table mb20" id={this.props.elementIdToUse}>
          <thead>
            <Entry
              header={true}
              formInitialising={this.props.formInitialising}
              onSelect={this.onSelectAll.bind(this)}
              selected={fieldValues && fieldValues['_all']}
              disableSelectors={this.props.disableSelectors}
            />
          </thead>
          <tbody>
            {
              (() => {
                if (this.props.list.length <= 0) {
                  return (<Entry
                    none={true}
                    disableSelectors={this.props.disableSelectors}
                  />)
                }
                return this.props.list.map((entry, index) => {
                  return (
                    <Entry
                      key={index}
                      value={entry}
                      formInitialising={this.props.formInitialising}
                      onSelect={this.onSelectEntryFactory(entry.id).bind(this)}
                      selected={fieldValues && fieldValues[entry.id+'']}
                      disableSelectors={this.props.disableSelectors}
                    />
                  )
                })
              })()
            }

          </tbody>
        </table>

      </div>
    );
  }
  onSelectEntryFactory(id) {
    return (select) => {
      log.debug('onSelectEntryFactory(%s): ', id, select);
      this.props.onFieldChange(id+'', select);
    }
  }
  onSelectAll(select) {
    const list = this.props.list;
    log.debug('onSelectAll(): ', select, list);
    if (!list) {
      return;
    }
    let all = {};
    all['_all'+this.props.type]=select;
    all = list.reduce((all, error) => {
      all[error.id+''] = select;
      return all;
    }, all);
    this.props.setFieldValues(all);
    // this.props.onFieldChange('_all'+this.props.type, select);
    // list.forEach((error) => {
    //   this.props.onFieldChange(error.id+'', select);
    // });

  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.onSelectAll(false);
  }
}


function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}

function mapDispatchersToProps(dispatch) {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchersToProps)(ErrorsAndWarningsListForm);